import { render } from "./ButtonIcon.vue?vue&type=template&id=0c256c0e&scoped=true"
import script from "./ButtonIcon.vue?vue&type=script&lang=js"
export * from "./ButtonIcon.vue?vue&type=script&lang=js"

import "./ButtonIcon.vue?vue&type=style&index=0&id=0c256c0e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c256c0e"]])

export default __exports__